// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Yxw6","tab":"ProcedureTabs_tab__shcnr"};